import React from 'react';
import styled from 'styled-components';
import Note from './Note';

const StyledContainer = styled.div`
  margin-top: 20px;
`;

const NotesSection = ({ notes }) => {
  return (
    <StyledContainer>
      {notes.map(note => <Note body={note.comment} author={note.author} date={note.time} />)}
    </StyledContainer>
  );
};

export default NotesSection;
